export const FETCH_CLINICS_BY_PREFECTURE =
  'containers/ClinicsPage/FETCH_CLINICS_BY_PREFECTURE';
export const FETCH_CLINICS_SUCCEEDED =
  'containers/ClinicsPage/FETCH_CLINICS_SUCCEEDED';
export const FETCH_CLINICS_FAILED =
  'containers/ClinicsPage/FETCH_CLINICS_FAILED';
